var HelpWindowConstants = {
    ClipboardCopyPaste:"CLIPBOARD_COPY_PASTE",
    Quickreference:"QUICK_REFERENCE",
    Print:"PRINT",
};

export default HelpWindowConstants;
